import classNames from "classnames";
import { PhosphorLink } from "components/Atoms/PhosphorIcon";
import React from "react";
import { isAppointmentLinked, LinkedItineraryItems } from "./utils";

interface Props {
  appointment: server.dto.PlannerAppointment
  linkedItems: LinkedItineraryItems
  onToggleLinked: () => void
}

const LinkAppointment = (props: Props) => {
  const isLinked = isAppointmentLinked(props.linkedItems, props.appointment);

  const [isHovering, setIsHovering] = React.useState(false);

  const classes = classNames("", {
    "green-bg": isLinked && !isHovering,
    "red-bg": isLinked && isHovering,
    "white-text": isLinked,
    "gray-250": !isLinked,
    hoverable: !isLinked
  });

  return <td
    className={classes}
    style={{ width: 30, cursor: "pointer", textAlign: "center" }}
    onClick={props.onToggleLinked}
    onMouseEnter={() => { setIsHovering(true); }}
    onMouseLeave={() => { setIsHovering(false); }}
  >
    <div className="padding-small">
      <PhosphorLink />
    </div>
  </td>;
};

export default LinkAppointment;